import api from "./api";

/* Script que contiene las llamadas a la API */
const accounts = {
    sendContactEmail: (params) => {
        const request = api.post("/sendMailLandingPage", params);

        return request.then((response) => response);
    },
};

export default accounts;
